import * as React from 'react'

export interface Props {
  className?: string
  color?: string
  size?: string
  padding? : string
}

export class HorizontalLine extends React.Component<Props> {
  public defaults = {
    className: 'w-full rounded-full',
    color: 'black',
    size: '2px',
    padding: '5em'
  }

  /*constructor (props: Props) {
    super(props)
  }*/

  public render (): React.ReactNode {

    let {className, color, size, padding} = this.props

    className = className ? className : this.defaults.className
    color = color ? color: this.defaults.color
    size = size ? size: this.defaults.size
    padding = padding ? padding: this.defaults.padding

    return(
        <div className={`flex w-full`}>
            <div className={`${className}`}
                style={{backgroundColor: color, height: size, marginLeft: padding, marginRight: padding}}></div>
        </div>
    )
  }
}

export default HorizontalLine
